import { Edit } from 'react-admin'

import { SpecialEventForm } from '../molecules/SpecialEventForm'
import { BackToScale, toScale } from './SpecialEventCreate'

// Pessimistic so a refused save is reported on the form instead of after the redirect.
export const SpecialEventEdit = () => (
  <Edit title="resources.scale_events.title_edit" redirect={toScale} mutationMode="pessimistic" actions={<BackToScale />}>
    <SpecialEventForm />
  </Edit>
)
